/**
 * 스캐너 앱(APK) 내려받기에 필요한 판단들.
 *
 * 화면이 아니라 여기 두는 이유는 이 저장소의 규칙이다 — 판단은 순수 함수로 빼고 테스트한다.
 */

/**
 * APK 크기를 사람이 읽는 말로. 휴대폰 데이터로 받을 수도 있으니 크기를 먼저 보여 준다 —
 * ML Kit 모델을 품고 있어 30MB 를 넘는다.
 */
export function apkSizeLabel(bytes: number | null | undefined): string {
  if (!bytes || bytes <= 0) return "?"
  const mb = bytes / (1024 * 1024)
  if (mb < 1) return `${Math.max(1, Math.round(bytes / 1024))}KB`
  return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)}MB`
}
